import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../public/images/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-edf633ce"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["width"];
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "掌尚名医CRM", -1));
const _hoisted_4 = [_hoisted_2, _hoisted_3];
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_affix = _resolveComponent("el-affix");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: _normalizeClass(["logo", $props.menuLeftWidth == '64px' ? 'logoMr' : 'logoMr2']),
    width: $props.menuLeftWidth
  }, _hoisted_4, 10, _hoisted_1), _createVNode(_component_el_affix, {
    offset: 0
  }, {
    default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
      class: "menuLeftScrollBar",
      style: _normalizeStyle({
        height: $props.clientHeight
      })
    }, {
      default: _withCtx(() => [_createVNode(_component_el_menu, {
        "default-active": $options.is_path,
        "active-text-color": "#409eff",
        "background-color": "",
        "text-color": "#fff",
        class: "el-menu-vertical-demo",
        "collapse-transition": true,
        collapse: $props.isCollapse,
        onOpen: $options.handleOpen,
        onClose: $options.handleClose,
        width: $props.menuLeftWidth
      }, {
        default: _withCtx(() => [($props.routes.length == 0 ? false : true) ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList($props.routes, (item, index) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: index
          }, [item.children && item.children.length > 0 && !item.hidden ? (_openBlock(), _createBlock(_component_el_sub_menu, {
            key: 0,
            index: item.path
          }, {
            title: _withCtx(() => [_createVNode(_component_el_icon, {
              size: 18
            }, {
              default: _withCtx(() => [item.meta.icon != 0 && item.meta.icon.indexOf('svg') != -1 ? (_openBlock(), _createBlock(_component_svg_icon, {
                key: 0,
                class: "default_color",
                "icon-class": item.meta.icon
              }, null, 8, ["icon-class"])) : item.meta.icon != 0 && item.meta.icon.indexOf('svg') == -1 ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.meta.icon), {
                key: 1
              })) : _createCommentVNode("", true)]),
              _: 2
            }, 1024), item.meta && item.meta.title ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.meta.title), 1)) : _createCommentVNode("", true)]),
            default: _withCtx(() => [(item.children.length >= 1 ? true : false) ? (_openBlock(true), _createElementBlock(_Fragment, {
              key: 0
            }, _renderList(item.children, (child, childIndex) => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: childIndex
              }, [!child.hidden ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 0,
                index: child.path,
                onClick: $event => $options.goPage(child.path, child.meta.title)
              }, {
                default: _withCtx(() => [!child.hidden ? (_openBlock(), _createElementBlock(_Fragment, {
                  key: 0
                }, [_createVNode(_component_el_icon, {
                  size: 15
                }, {
                  default: _withCtx(() => [child.meta.icon != 0 && child.meta.icon.indexOf('svg') != -1 ? (_openBlock(), _createBlock(_component_svg_icon, {
                    key: 0,
                    class: "svg_default2",
                    "icon-class": child.meta.icon
                  }, null, 8, ["icon-class"])) : child.meta.icon != 0 && child.meta.icon.indexOf('svg') == -1 ? (_openBlock(), _createBlock(_resolveDynamicComponent(child.meta.icon), {
                    key: 1
                  })) : _createCommentVNode("", true)]),
                  _: 2
                }, 1024), child.meta && child.meta.title ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(child.meta.title), 1)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]),
                _: 2
              }, 1032, ["index", "onClick"])) : _createCommentVNode("", true)], 64);
            }), 128)) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["index"])) : _createCommentVNode("", true)], 64);
        }), 128)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["default-active", "collapse", "onOpen", "onClose", "width"])]),
      _: 1
    }, 8, ["style"])]),
    _: 1
  })], 64);
}